import '../sass/project.scss';

/* Project specific Javascript goes here. */
(function () {
  'use strict';

  //////////////////////////
  // Theme helpers
  //////////////////////////

  const getStoredTheme = () => localStorage.getItem('theme');
  const setStoredTheme = (theme) => localStorage.setItem('theme', theme);

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme();
    if (storedTheme === 'light' || storedTheme === 'dark') {
      return storedTheme;
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  };

  const setTheme = (theme) => {
    document.documentElement.setAttribute('data-bs-theme', theme);
  };

  //////////////////////////
  // Theme toggle (single button)
  //////////////////////////

  const updateToggleIcon = (theme) => {
    const icon = document.getElementById('theme-toggle-icon');
    if (!icon) return;

    if (theme === 'dark') {
      icon.className = 'bi bi-sun-fill fs-5';
    } else {
      icon.className = 'bi bi-moon-stars-fill fs-5';
    }
  };

  const toggleTheme = () => {
    const currentTheme =
      document.documentElement.getAttribute('data-bs-theme') || 'light';

    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

    setStoredTheme(newTheme);
    setTheme(newTheme);
    updateToggleIcon(newTheme);
  };

  //////////////////////////
  // Init on DOM ready
  //////////////////////////

  window.addEventListener('DOMContentLoaded', () => {
    // Apply theme on load
    const initialTheme = getPreferredTheme();
    setTheme(initialTheme);
    updateToggleIcon(initialTheme);

    // Toggle button
    const themeToggleBtn = document.getElementById('theme-toggle');
    if (themeToggleBtn) {
      themeToggleBtn.addEventListener('click', toggleTheme);
    }

    //////////////////////////
    // Tooltips
    //////////////////////////
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.map((tooltipTriggerEl) => {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  });

  //////////////////////////
  // Bootstrap validation
  //////////////////////////

  const needsValidation = document.querySelectorAll('.needs-validation');

  Array.prototype.slice.call(needsValidation).forEach((form) => {
    form.addEventListener(
      'submit',
      (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      },
      false
    );
  });

})();
